<template>
    <div class="flex w-full items-center justify-center">
        <div class="dasiy-join space-x-3 font-semibold">
            <button v-for="(item, index) in pages" :key="index" :class="{ ' text-primary': item === props.data.currentPage }" @click="changePage(item)">{{ item }}</button>
        </div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps<{
    data: {
        pageSize: number;
        total: number;
        currentPage: number;
    };
}>();
const emit = defineEmits(["change"]);
const pages = computed(() => {
    return Math.ceil(props.data.total / props.data.pageSize);
});
const changePage = (page: number) => {
    emit("change", page);
};
</script>
<style lang="scss" scoped></style>
